import logdown from 'logdown';
var logger = logdown('auth', {
  prefixColor: '#0099ff'
});
export var getDateString = function getDateString() {
  return "[".concat(new Date().toLocaleTimeString(), "] ");
};
export default logger;